export { default } from './FlatList';
